import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { BackButton, EditButton } from "../../../../Components/Utils/Buttons";
import { NormalHeading } from "../../../../Components/Utils/Heading";
import NuDate from "../../../../Components/Utils/NuDate";
import CommonComments from "../../../../Components/Utils/commonComments";
import NuAmount from "../../../../Components/Utils/NuAmount";
import { Button, Progress } from "antd";
import ToggleUp from "../../../../Components/Icons/ToggleUp";
import ToggleDown from "../../../../Components/Icons/ToggleDown";

import { useFormik } from "formik";
import { handleKeyDown } from "../../../../Components/Utils/OtherFunction";
import { MainForm, MainFormInput } from "../../../../Components/Utils/MainForm";
import Modal from "../../../../Components/Utils/AttachmentView";
import PDFViewer from "../../../../Components/Utils/PDFViewer";
import FilesView from "../../../../Components/Utils/FilesView";
import ViewIcon from "../../../../Components/Icons/ViewIcon";
import EditIcon from "../../../../Components/Icons/Edit";
import ApprovalComponent from "../../../../Components/Utils/approvalComponent";
import DeleteIcon from "../../../../Components/Icons/Delete";
import axiosInstance from "../../../../Services/axiosCommon";
import { NuInput } from "../../../../Components/Utils/Input";
import { ExclamationCircleFilled } from "@ant-design/icons";
import EditCalendar from "../Calender/EditCalendar";
import { useToast } from "../../../../Components/Others/ToastServices";
import EditTaskAssignee from "./EditTaskAssignee";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import ViewTask from "./ViewTask";
import InSchedulelayout from "./InSchedulelayout";
import { GetAccess } from "../../../../Components/Utils/roles";


function ViewShedule(onClose, getData, id) {
  const { scheduleViewId } = useParams();
  const location = useLocation();
  const cdata = location.state?.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  const [tasks, setTasks] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
  const [percentOpenTask, setPercentOpenTask] = useState(false);
  const [newCompletion, setNewCompletion] = useState(0);
  const [loading, setLoading] = useState(false);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);

  const [data,setData] = useState(cdata? cdata:null); 
  
 
  

  function getView() {
    axiosInstance 
      .get(`/schedules/${scheduleViewId}`)
      .then((res) => {
        setData(res.data?.data);       
      })
      .catch(err=>{
        console.log("err", err);
      })
  }
  
  useEffect(() => {
    // if (!cdata) {
      getView();
    // }
  }, [])


  useEffect(() => {
    fetchTasks();
  }, [data]);

  const fetchTasks = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/calendar/tasks/${scheduleViewId}`);
      setTasks(response.data?.data);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleTaskClick = (task) => {
    console.log(task);

    setSelectedTask(task);
    setIsTaskModalOpen(true);
  };
  console.log(selectedTask, "selectedTasks");

  const handleUpdateCompletion = async () => {
    if (!selectedTask) return;

    try {
      setLoading(true);
      await axiosInstance.put(`/calendar/task-completion/${selectedTask.id}`, {
        taskCompletion: newCompletion,
      });
      fetchTasks();
      setPercentOpenTask(false);
    } catch (error) {
      console.error("Error updating task completion:", error);
    } finally {
      setLoading(false);
    }
  };

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const toast = useToast();

  const cancelDelete = () => {
    setShowDeleteConfirm(false);
    setItemToDelete(null);
  };
  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setShowDeleteConfirm(true);
  };
  const confirmDelete = async (id) => {
    if (!itemToDelete) return;

    try {
      const res = await axiosInstance.delete(
        `/schedules/task/${selectedTask.id}`
      );
      if (res?.data?.status) {
        fetchTasks();
        toast.open({
          type: "success",
          message: "Success",
          description: res.data?.msg || "Deleted Successfully.",
        });
      } else {
        toast.open({
          type: "error",
          message: "Error",
          description: res.data.error || "Network error.",
        });
      }
    } catch (err) {
      toast.open({
        type: "error",
        message: "Error",
        description: err.response?.data?.error || "Delete failed.",
      });
    } finally {
      setShowDeleteConfirm(false);
      setItemToDelete(null);
    }
  };
 

  const [percentOpen, setPercentOpen] = useState(false);
  const [createNew, setCreateNew] = useState({
    name: "",
  });
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };
 

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,

    onSubmit: (values) => console.log("Form Submitted", values),
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [filePathList, setFilePathList] = useState([]);

  useEffect(() => {
    if (
      data?.attachments !== null &&
      data?.attachments !== "None" &&
      data?.attachments !== "[]"
    ) {
      setFilePathList(data?.attachments?.length > 0 ? data?.attachments : []);
    }
  }, [data]);

const [showPdfComponent, setShowPdfComponent] = useState(false);

const handlePdfIconClick = () => {
  setShowPdfComponent(true);
};
  const [viewPDF,setViewPDF] = useState(null);

const ViewPDF = async () => {
  try {
      const response = await axiosInstance.get(`/schedules/report2/${scheduleViewId}`, {
          responseType: 'blob' // Important to specify the response type as blob
      });

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

      // Create a link element
      let Viewlink = window.URL.createObjectURL(pdfBlob);
      setViewPDF(Viewlink);

  } catch (error) {
      console.error('Error downloading the PDF:', error);
  }
};

useEffect(() => {
  ViewPDF()
},[scheduleViewId,data])
  return (
    <InSchedulelayout
    EditAccess={GetAccess("customers_create")}
      >
    
        <div className="w-full h-full mt-0.5 overflow-y-auto">

      <div className="w-full mx-auto h-[calc(100vh-175px)]  rounded-md md:overflow-hidden   md:flex gap-2 text-[#111537]">
        <div className="md:w-[70%]  bg-white rounded-md drop-shadow-lg py-1 overflow-hidden ">
          <div className="sm:w-[98%]  bg-white px-2 mx-2 border border-gray py-2 rounded-lg sm:flex justify-between items-center  z-10">
            <div className="grid  items-center px-2 w-[70%]">
            <div className="flex text-[14px] mb-2 text-[#111537] font-semibold ">
                <p className="w-[26%] 2xl:w-[20%] pr-[2px] ">{data?.refNumber} </p>
                <p> : </p>
                <p className="w-[75%] pl-[2px] text-sm font-normal text-[#606279]">
                  {data?.description || "None"}
                </p>
              </div>
              <div className="flex gap-4 justify-between">
                <p className="text-xs text-[#111537]">
                  Date :{" "}
                  {data?.date ? (
                    <NuDate value={data?.date} format="DD-MMM-YYYY" />
                  ) : (
                    "N/A"
                  )}
                </p>
              </div>
            </div>
            <div className="sm:grid   justify-end w-[30%]">
              {/* <div className="pb-1 flex justify-end">
                <p
                  className="text-xs cursor-pointer text-white bg-[#6A9C89] rounded-md inline-flex w-auto h-5 px-2 mr-1 flex-shrink-0 items-center justify-center"
                  onClick={() => handleTaskClick(data?.task)}
                >
                  Task
                </p>
              </div> */}
              <div className="border mt-1 sm:mt-0 rounded-md mr-3 border-textColor-main text-xs inline-flex w-auto  flex-shrink-0  justify-center">
                <p className="  bg-white  text-black  p-1 rounded-l-md  ">
                  Status{" "}
                </p>
                <p className="bg-textColor-main text-white p-1 items-center rounded-r-md">
                  {" "}
                  {data?.status || "None"}
                </p>
              </div>
            </div>
          </div>

          <div className="h-[calc(100vh-200px)] overflow-y-auto p-2 pb-8 ">
            <div className=" w-full flex flex-wrap  px-2 border border-gary mt-2  rounded-lg ">
              <div className=" w-full sm:grid grid-cols-2 gap-x-8 ">

                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Assignee
                  </p>
                  
                      <div className="w-[65%] py-2 text-xs font-medium text-[#606279] flex flex-wrap">
  <span className="mr-1">:</span>
  {data?.assignees?.map((assignees, idx) => (
    <span key={idx} className="text-xs font-medium  text-[#606279] mr-1">
      {assignees.assigneeName}
      {idx < data.assignees.length - 1 && ','}
    </span>
  ))}
</div>
                
                </div>

               
               

              
               
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Location
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.location}
                  </p>
                </div>
              </div>
            </div>
            <div className="flex gap-4 mt-4">
              <div className=" w-full sm:w-[50%] ">
                <p className=" p-1 text-xs font-medium text-[#111537]">
                  Attachments
                </p>
                <div className=" border border-gary  overflow-y-scroll h-28 rounded-lg p-2">
                  <div className="w-full flex gap-2 flex-wrap ">
                    {data?.attachments &&
                      filePathList.map((imgs, idx) => {
                        console.log("img", imgs);
                        return <FilesView fileView={imgs} key={idx} />;
                      })}
                  </div>
                </div>
              </div>
            </div>
          
          </div>
        </div>
        <div className="md:w-[30%] bg-white rounded-lg drop-shadow-lg py-1 mt-3 md:mt-0">
          <div className="h-[98%] overflow-y-scroll p-2 ">
            {/* <ApprovalComponent
            id={id}
            getUrl={getUrl}
            putUrl={putUrl}
            statusUrl={statusUrl}
            refSetData={setData}
            data={data}
            type={"PR"}
            preUrlName={"PR"}
            /> */}
              {/* <div className="w-full grid  border border-gary   rounded-lg">
              <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                <p className="text-xs text-white font-medium">Client Detail</p>
              </div>

              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  Name
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  : {data?.clientName}
                </p>
              </div>
              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  {" "}
                  Reference
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  {" "}
                  : {data?.clientRefNumber}
                </p>
              </div>
              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  {" "}
                  Contract
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  {" "}
                  : {data?.contractRefNumber}
                </p>
              </div>
            </div> */}
            {/* <div className="w-full grid  border border-gary   rounded-lg">
              <div className="bg-baseColor-primary  p-2 rounded-t-lg flex justify-between">
                <p className="text-xs text-white font-medium">Task</p>
                <div
          className="cursor-pointer flex gap-2"
          onClick={() => {
           
          }}
        >
          <ViewIcon color="white" />
         

        </div>
        {data?.task?.map()}
              </div>
             
            
              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                Assignees
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  : {data?.assignees}
                </p>
              </div>
              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  {" "}
                  description
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  {" "}
                  : {data?.description}
                </p>
              </div>
            </div> */}

<div className="w-full grid  border border-gary   rounded-lg ">
           <p className="text-xs text-white font-medium bg-baseColor-primary  p-2 rounded-t-lg">Report </p>
           <div className=" w-full flex flex-wrap overflow-y-scroll h-16">
         

        <div onClick={handlePdfIconClick} className="cursor-pointer m-1 w-auto h-[25px] flex items-center  justify-between  rounded p-[2px] border ">
          <svg
            width="20"
            height="20"
            fill="#3369ff"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
          </svg>
          <p className=' w-auto  text-[9px]'>{data?.refNumber}</p>
        </div>
        </div>
        </div>

            <div className="w-full h-auto flex  border border-gary mt-4 overflow-hidden rounded-lg">
              <CommonComments
                visible={true}
                title="Comments"
                mainId={data?.prId}
                addurl={"/pr-comments/new-comment"}
                geturl={`/pr-comments/by-PR/${data?.prId}`}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
        {selectedImage?.file.split(".").reverse()[0] == "pdf" ? (
          <PDFViewer pdfFile={selectedImage?.file} />
        ) : (
          <img src={selectedImage?.file} alt={selectedImage?.file} />
        )}
      </Modal>
      {isTaskModalOpen && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[97%] max-w-[100%] h-[98%] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-sm font-semibold">Task Details</h3>
              <button
                onClick={() => setIsTaskModalOpen(false)}
                className="text-gray-500 hover:text-gray-700 text-2xl"
              >
                ×
              </button>
            </div>

            <div className="overflow-x-auto ">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-900 w-[30%]">
                      Description
                    </th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-900 w-[10%]">
                      Date
                    </th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-900 w-[15%]">
                      Assignee
                    </th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-900 w-[10%]">
                      Status
                    </th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-900 w-[10%]">
                      Completion
                    </th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-900 w-[5%]">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {tasks.map((task) => (
                    <tr key={task.id}>
                      <td className="px-4 py-3 whitespace-nowrap text-xs text-gray-500 w-[30%]">
                        {task.description || "N/A"}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-xs text-gray-500 w-[10%]">
                        {task.date ? (
                          <NuDate value={task.date} format="DD-MMM-YYYY" />
                        ) : (
                          "N/A"
                        )}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-xs text-gray-500 w-[15%]">
                        {task.assignees?.length > 0 ? (
                          <div className="flex flex-wrap gap-1">
                            {task.assignees.map((assignee, index) => (
                              <span
                                key={index}
                                className="inline-block bg-gray-100 rounded-full px-2 py-0.5 text-xs text-gray-700"
                              >
                                {assignee.assigneeName || `Assignee ${index + 1}`}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <span className="text-gray-400">Unassigned</span>
                        )}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-xs text-gray-500 w-[10%]">
                        {task.status || "N/A"}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-xs text-gray-500 w-[10%]">
                        <Progress
                          onClick={() => {
                            setSelectedTask(task);
                            setNewCompletion(task.taskCompletion || 0);
                            setPercentOpenTask(true);
                          }}
                          type="circle"
                          size={30}
                          strokeWidth={12}
                          format={(percent) => (
                            <span
                              className={`cursor-pointer ${
                                percent > 95
                                  ? "text-[#87d068]"
                                  : percent > 50
                                  ? "text-[#108ee9]"
                                  : "text-[#D2BD00]"
                              } text-xs font-semibold`}
                            >
                              {percent}
                            </span>
                          )}
                          percent={
                            typeof task.taskCompletion === "number"
                              ? task.taskCompletion
                              : 0
                          }
                          strokeColor={
                            (task.taskCompletion || 0) > 95
                              ? { "0%": "#87d068", "100%": "#87d068" }
                              : (task.taskCompletion || 0) > 50
                              ? { "0%": "#108ee9", "100%": "#108ee9" }
                              : { "0%": "#D2BD00", "100%": "#D2BD00" }
                          }
                        />
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium">
                        <div className="flex gap-2">
                          <span  className="flex justify-end"
                            onClick={() => {
                              setSelectedTask(task);
                              setIsViewModalOpen(true);
                            }}>
                            <ViewIcon />
                          </span>
                          <span
                            className="flex justify-end"
                            onClick={() => {
                              setSelectedTask(task);
                              setIsEditModalOpen(true);
                            }}
                          >
                            <EditIcon height="14" color="blue" />
                          </span>

                          <button
                            className="text-red-500 hover:text-red-700 "
                            onClick={() => handleDeleteClick(task)}
                            disabled={loading}
                          >
                            <DeleteIcon />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {percentOpenTask && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[90%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Update Task Completion</h3>
              <button
                onClick={() => setPercentOpenTask(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                ×
              </button>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Task Percentage
              </label>
              <div className="flex items-center gap-2">
                <input
                  type="number"
                  className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  value={newCompletion}
                  onChange={(e) => {
                    const value = parseInt(e.target.value);
                    if (!isNaN(value) && value >= 0 && value <= 100) {
                      setNewCompletion(value);
                    }
                  }}
                  min={0}
                  max={100}
                  placeholder="0"
                />
                <span>%</span>
              </div>
            </div>

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setPercentOpenTask(false)}
                className="px-4 py-2 text-sm text-gray-700 bg-gray-100 rounded hover:bg-gray-200"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdateCompletion}
                disabled={loading}
                className="px-4 py-2 text-sm text-white bg-blue-600 rounded hover:bg-blue-700 disabled:opacity-50"
              >
                {loading ? "Updating..." : "Update"}
              </button>
            </div>
          </div>
        </div>
      )}

      {isEditModalOpen && (
        <EditTaskAssignee
          open={isEditModalOpen}
          onCancel={() => setIsEditModalOpen(false)}
          task={selectedTask}
          id={selectedTask?.id}
          fetchTasks={fetchTasks}
        />
      )}
       {isViewModalOpen && (
      //    <Modal
      //    open={isViewModalOpen}
      //    onCancel={()=>setIsViewModalOpen(false)}
      //    title={"View"}
      //    width="50%"
      //    centered
      //       className="my-modal"
      
      //    footer={[]}
      //  >
       
         <ViewTask
          open={isViewModalOpen}
          onCancel={() => setIsViewModalOpen(false)}
          task={selectedTask}
          id={selectedTask?.id}
          fetchTasks={fetchTasks}
        />     
        //  </Modal>
        
      )}

      {showDeleteConfirm && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h3 className="text-sm font-medium mb-4">Warning</h3>
            <p className="mb-6 text-xs">
              Are you sure, you want to delete this Task?
            </p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={cancelDelete}
                className="px-4 py-[8px] text-xs hover:bg-gray-300 rounded-md flex items-center text-textColor-main bg-[#E6F2F2] cursor-pointer"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="px-4 py-[8px] text-xs bg-textColor-main cursor-pointer rounded-md text-white"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
     {showPdfComponent && (
      <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
      <div className="animate-scale-in relative w-[98%] h-[98%] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
        <button
                  className="absolute top-2 right-2 text-white bg-red-600"
                  onClick={() => setShowPdfComponent(false)}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <PDFViewer pdfFile={viewPDF}/>
          
         
         
        </div>
      </div>
    )}
    </InSchedulelayout>
  );
}

export default ViewShedule;
